import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Formik } from 'formik';
import { useResident } from '../context/useResident';
import { residentValidationSchema } from '../validations/residentValidationSchema';
import { initialValues } from '../constants/residentConstants';
import { LoadingSpinner } from '../components/ResidentForm/LoadingSpinner';
import { ErrorSnackbar } from '../components/ResidentList/ErrorSnackbar';
import { FormContainer } from '../components/ResidentForm/FormContainer';
import { FormHeader } from '../components/ResidentForm/FormHeader';
import { ResidentForm } from '../components/ResidentForm/ResidentForm';
import { FormActions } from '../components/ResidentForm/FormActions';
import { getAttributeValue, getCnhNumberFromAttributes, getCnhExpirationFromAttributes } from '../../../utils/getAttributeLabelAndValue';
import { useAuth } from '../../auth';



export default function ResidentFormPage() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const auth = useAuth();
  const {
    residentData,
    isDataLoading,
    createResident,
    updateResident,
    isSubmitting,
    error,
    setError
  } = useResident();

  // Função para processar os dados do residente para o formato do formulário
  const processResidentDataForForm = (residentData: any) => {
    if (!residentData) return {
      ...initialValues,
      tenantId: auth.selectedTenant.id,
    };

    console.log('ResidentFormPage - residentData:', residentData);
    console.log('ResidentFormPage - attributes:', residentData.attributes);

    // Buscar unidade/apartamento - pode estar em 'unit' ou 'apartment'
    const unitAttr = getAttributeValue(residentData.attributes, 'unit') 
      || getAttributeValue(residentData.attributes, 'apartment');
    
    const sectionAttr = getAttributeValue(residentData.attributes, 'section_name') 
      || getAttributeValue(residentData.attributes, 'section');

    let unitValue = '';
    let sectionValue = '';

    // Se unit/apartamento é um objeto (como apartment com number e tower_name)
    if (typeof unitAttr === 'object' && unitAttr !== null) {
      unitValue = unitAttr.number || '';
      sectionValue = unitAttr.tower_name || '';
    } 
    // Se unit/apartamento é uma string
    else if (typeof unitAttr === 'string') {
      unitValue = unitAttr;
    }

    // Se section_name é uma string separada
    if (typeof sectionAttr === 'string' && !sectionValue) {
      sectionValue = sectionAttr;
    }

    return {
      // Dados básicos
      name: residentData.name || '',
      email: residentData.email || '',
      status: residentData.status || '',
      role: residentData.role || '',
      phoneNumber: residentData.phoneNumber || '',
      documentNumber: residentData.documentNumber || '',
      description: residentData.description || '',
      imageUrl: residentData.imageUrl || '',
      
      // Dados dos atributos
      status_flag: getAttributeValue(residentData.attributes, 'status_flag') || 'ACTIVE',
      type_flag: 'CONDOMINO',
      birth_date: getAttributeValue(residentData.attributes, 'birth_date') || '',
      gender_flag: getAttributeValue(residentData.attributes, 'gender_flag') || 'MALE',
      marital_flag: getAttributeValue(residentData.attributes, 'marital_flag') || 'SINGLE',
      phone_number: getAttributeValue(residentData.attributes, 'phone_number') || '',
      cnh_number: getCnhNumberFromAttributes(residentData.attributes) || '',
      cnh_expiration: getCnhExpirationFromAttributes(residentData.attributes) || '',
      nationality: getAttributeValue(residentData.attributes, 'nationality') || '',
      unit: unitValue,
      section_name: sectionValue,
      
      // Campos do formulário
      password: '',
      confirmPassword: '',
      avatarFile: null,
      imagePreview: '', // Será preenchido quando usuario selecionar nova imagem
    };
  };

  async function handleSubmit(formData: any) {
    try {
      const formDataWithTenant = {
        ...formData,
        tenants: [{
          id: selectedTenant.trim(),
          role: 'customer'
        }],
      };
      
      if (isEdit && id) {
        await updateResident(id, formDataWithTenant);
        navigate(`/residents/${id}`);
      } else {
        await createResident(formDataWithTenant);
        navigate('/residents');
      }
    } catch (error) {
      console.error('Erro ao salvar residente:', error);
    }
  }

  function handleCancel() {
    navigate(-1);
  }

  if (isEdit && isDataLoading) {
    return (
      <FormContainer>
        <LoadingSpinner />
      </FormContainer>
    );
  }

  const formInitialValues = isEdit && residentData 
    ? processResidentDataForForm(residentData)
    : initialValues;

  console.log('ResidentFormPage - formInitialValues:', formInitialValues);

  return (
    <>
      <ErrorSnackbar 
        error={error} 
        onClose={() => setError(null)} 
      />
      
      <FormContainer>
        <FormHeader mode={isEdit ? 'edit' : 'create'} />
        
        <Formik
          initialValues={formInitialValues}
          validationSchema={residentValidationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isValid, dirty, values, errors }) => {
            console.log('Formik - values:', values);
            console.log('Formik - errors:', errors);
            return (
              <form onSubmit={(e) => { e.preventDefault(); handleSubmit(values); }}>
                <ResidentForm
                  mode={isEdit ? 'edit' : 'create'}
                  loading={isSubmitting}
                  onCancel={handleCancel}
                />
              </form>
            );
          }}
        </Formik>
      </FormContainer>
    </>
  );
}